
import { PadelPlayer } from "@/models/padelPlayer.interface";
import { getColorCodeGroupFromPlayer } from "@/services/americanoService";
import { sortByScore } from "@/services/scoreService";
import store from "@/store/index";
import { defineComponent } from "vue";

export default defineComponent({
    data: function() {
        return {
            twoGroupOfPlayers: false,
            showTwoTables: false,
        };
    },
    methods: {
        goBack(): void {
            store.commit.americanoStore.DECREMENT_STEP();
        },
        newGame(): void {
            store.dispatch.americanoStore.newGame();
        },
        changeGrouping() {
            if (!this.$data.twoGroupOfPlayers) {
                this.$data.showTwoTables = false;
                return;
            }
            this.$data.showTwoTables = !this.$data.showTwoTables;
        },
        getColorCodeGroup(player: PadelPlayer) {
            if (store.getters.americanoStore.getRules.colorCode === false) {
                return 0;
            }

            return getColorCodeGroupFromPlayer(
                player,
                store.getters.americanoStore.getPlayers,
                store.getters.americanoStore.getGames
            );
        },
        getAllPlayers() {
            const players = this.getPlayers;

            if (players.length === 16) {
                this.$data.twoGroupOfPlayers = true;
            }

            return players;
        },
        getFirstGroup() {
            const players = store.getters.americanoStore.getPlayers;

            const firstGroupPlayers = [] as PadelPlayer[];

            players.forEach(player => {
                const group = getColorCodeGroupFromPlayer(
                    player,
                    players,
                    store.getters.americanoStore.getGames
                );
                if (group === 1) {
                    firstGroupPlayers.push(player);
                }
            });

            return firstGroupPlayers;
        },
        getSecondGroup() {
            const players = store.getters.americanoStore.getPlayers;

            const secondGroupPlayers = [] as PadelPlayer[];

            players.forEach(player => {
                const group = getColorCodeGroupFromPlayer(
                    player,
                    players,
                    store.getters.americanoStore.getGames
                );
                if (group === 2) {
                    secondGroupPlayers.push(player);
                }
            });

            return secondGroupPlayers;
        },
        shouldShowTwoTables() {
            return this.$data.twoGroupOfPlayers && this.$data.showTwoTables;
        },
    },
    computed: {
        getPlayers() {
            store.dispatch.americanoStore.sortPlayersByScore();
            return store.getters.americanoStore.getPlayers;
        },
    },
});
